// Constants
import { GIL_API_CHANNEL } from 'constants/api.constants';
// Utilities
import { getCheckoutIdFromUrl } from 'utils/browser-url.utils';

const ERROR_LOG_SERVICE_CONFIGURATION = {
  ...GIL_API_CHANNEL,
  endpoint: 'gil-api-mng-amz-ldg/v1/checkout/orders/:checkoutId/log',
  pathParams: {
    checkoutId: getCheckoutIdFromUrl(),
  },
};

export { ERROR_LOG_SERVICE_CONFIGURATION };
